export const tokenKey = "emr_token";

export const getToken = () => {
  return localStorage.getItem(tokenKey);
};
export const getTokenUser = () => {
  return localStorage.getItem("tokenUser");
};

export const setToken = (token) => {
  localStorage.setItem(tokenKey, token);
};
export const setTokenUser = (token) => {
  localStorage.setItem("tokenUser", token);
};

export const removeToken = () => {
  localStorage.removeItem(tokenKey);
};
export const removeTokenUser = () => {
  localStorage.removeItem("tokenUser");
};